<template>

  <PageHeader
    title="Workflow Configuration"
    subtitle="Statuses, instructions, configurations, and metric workflows."
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        class="px-6"
        :tabs="tabs"
        no-border
      />
    </template>
  </PageHeader>

  <div class="flex-1 bg-gray-50">
    <!-- Tabs with own card wrappers -->
    <Overview_TaskConfigurationManager v-if="activeTab === 'task-configuration'" />
    <MetricWorkflowBuilder v-if="activeTab === 'metric-workflows'" />
    <Overview_WorkTypeManager v-if="activeTab === 'work-types'" />

    <!-- Tabs that use the shared card wrapper -->
    <div v-if="!['task-configuration', 'metric-workflows', 'work-types'].includes(activeTab)" class="p-4">
      <div class="bg-white rounded-lg shadow-sm border border-gray-200">
        <Overview_TaskStatusManager v-if="activeTab === 'task-statuses'" />
        <Overview_TaskInstructionTypeManager v-if="activeTab === 'instruction-types'" />
      </div>
    </div>
  </div>
</template>

<script>
import TaskStatusManager from "@/components/Portal/Admin/Components/TaskStatusManager.vue";
import TaskInstructionTypeManager from "@/components/Portal/Admin/Components/TaskInstructionTypeManager.vue";
import TaskConfigurationManager from "@/components/Portal/Admin/Components/TaskConfigurationManager.vue";
import MetricWorkflowBuilder from "@/components/Portal/Admin/Components/MetricWorkflowBuilder.vue";
import WorkTypeManager from "@/components/Portal/Admin/Components/WorkTypeManager.vue";
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'WorkflowConfigManager',

  components: {
    Overview_WorkTypeManager: WorkTypeManager,
    Overview_TaskStatusManager: TaskStatusManager,
    Overview_TaskInstructionTypeManager: TaskInstructionTypeManager,
    Overview_TaskConfigurationManager: TaskConfigurationManager,
    MetricWorkflowBuilder,
    PageHeader,
    Page_Tabs
  },

  computed: {
    tabs() {
      return [
        {
          key: 'task-statuses',
          label: 'Task Statuses',
          icon: ['fas', 'check-circle'],
          description: 'Define and manage the status states that tasks can have in your workflow',
          to: '/tenantadmin/workflow-configuration/task-statuses',
        },
        {
          key: 'instruction-types',
          label: 'Instruction Types',
          icon: ['fas', 'clipboard-list'],
          description: 'Reference guide for instruction types and their config contracts',
          to: '/tenantadmin/workflow-configuration/instruction-types',
        },
        {
          key: 'task-configuration',
          label: 'Task Configuration',
          icon: ['fas', 'cogs'],
          description: 'Set up task types, their properties, and available actions',
          to: '/tenantadmin/workflow-configuration/task-configuration',
        },
        {
          key: 'metric-workflows',
          label: 'Metric Workflows',
          icon: ['fas', 'project-diagram'],
          description: 'Build and manage workflows by linking tasks to metrics in specific sequences',
          to: '/tenantadmin/workflow-configuration/metric-workflows',
        },
        {
          key: 'work-types',
          label: 'Work Types',
          icon: ['fas', 'briefcase'],
          description: 'Define types of work that can be performed and associated with tasks',
          to: '/tenantadmin/workflow-configuration/work-types',
        },
      ];
    },
    activeTab() {
      return this.$route.meta.workflowTab || 'task-configuration';
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
